import React, { useState, useEffect } from "react";
import apiService from '../Services/apiService';
import { Link, useNavigate } from "react-router-dom";
import '../styles/LoginCss.css';
import TruveyGreenLogo from '../Asset/Images/XSO-White.png';
import  UpperFooter from '../Component/UpperFooter';

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [ip, setIp] = useState("");
  const [DeviceType, setDeviceInfo] = useState("");

  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem("JWTToken");
    if (token) {
      navigate("/SurveyList")
    }
    fetch("https://api64.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => setIp(data.ip))
      .catch((error) => console.error("Error fetching IP:", error));

      const userAgent = navigator.userAgent.toLowerCase();
      let deviceType = "Unknown Device";
  
      if (/windows/i.test(userAgent)) {
        deviceType = "Windows PC";
      } else if (/macintosh|mac os x/i.test(userAgent)) {
        deviceType = "Mac";
      } else if (/iphone/i.test(userAgent)) {
        deviceType = "iPhone";
      } else if (/ipad/i.test(userAgent)) {
        deviceType = "iPad";
      } else if (/android/i.test(userAgent)) {
        deviceType = "Android";
      } else if (/linux/i.test(userAgent)) {
        deviceType = "Linux";
      } else if (/tablet|playbook|silk/i.test(userAgent)) {
        deviceType = "Tablet";
      } else if (/mobile/i.test(userAgent)) {
        deviceType = "Mobile";
      }
  
      setDeviceInfo(deviceType);
  }, []);

  // form submission
  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    if (!email || !password) {
      setErrorMessage("Please fill out all fields.");
      return;
    }

    try {
      const response = await apiService.Userlogin(email, password, ip, DeviceType);
      if (response != null) {
        const JWTToken = response.TOKEN;
        if (!response.TOKEN) {
          setErrorMessage("Invalid email or password. Please try again.");
          return;
        }
        else {
          setErrorMessage("Login Successfully");
          localStorage.setItem("UserEmail", email)
          localStorage.setItem("JWTToken", JWTToken);
          navigate("/SurveyList");
        }
      } else {
        setErrorMessage("Invalid email or password. Please try again.");
      }
    } catch (error) {
      setErrorMessage(error.message);
    }
  };

  return (
    <>
      <section className="TruveyBG min-hight99vh py-5">
        <div className="container">
          <div className="row d-flex align-items-center justify-content-center h-100">
            <div className="col-md-7 col-lg-6 col-xl-5">
              <div className="d-none d-md-block text-center" style={{ width: "100%" }}>
                <Link to="/" className="d-block">
                  <img src={TruveyGreenLogo} alt="Logo" className="w-50" />
                </Link>
              </div>
            </div>
            <div
              className="col-md-5 col-lg-5 col-xl-5 offset-xl-1 p-3 bg-white"
              style={{
                borderRadius: "1rem",
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
              }}
            >
              <div className="p-3">
                <h2 className="text-center fw-bold mb-4">Sign in</h2>
                <form onSubmit={handleLogin}>
                  <div className="form-group">
                    <label htmlFor="email" className="form-label">
                      Registered Email <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      className="form-control mb-2"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="password" className="form-label">
                      Password <span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="input-group">
                      <input
                        type="password"
                        id="password"
                        className="form-control rounded-2"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />

                    </div>
                  </div>
                  <button
                    type="submit"
                    className="btn btn-custom btn-lg btn-block form-control mt-4 mb-4"
                  >
                    Login
                  </button>
                  {errorMessage && <p className="text-danger">{errorMessage}</p>}
                </form>

                <div className="d-flex justify-content-around align-items-center mt-4 mb-4">
                  <p>
                    <Link to="/ForgetPassword">Forgot password?</Link>
                  </p>
                  <p>
                    Don't have an account? <Link to="/SignUp">Register now</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <UpperFooter />

    </>
  );
};

export default Login;
